const DEFAULT_PACKAGE_CREATE_STATUSES = ['agendado', 'autorizar', 'implementar'];

export function resolvePackageCreateStatuses(configured?: string[] | null): Set<string> {
  if (configured?.length) {
    return new Set(configured);
  }
  return new Set(DEFAULT_PACKAGE_CREATE_STATUSES);
}

export function changeAllowsSubtaskPackage(
  status: string,
  configured?: string[] | null,
): boolean {
  return resolvePackageCreateStatuses(configured).has(status);
}

export const PACKAGE_CREATE_STATUS_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'avaliar', label: 'Avaliar' },
  { value: 'agendado', label: 'Agendado' },
  { value: 'autorizar', label: 'Autorizar' },
  { value: 'transporte', label: 'Transporte' },
  { value: 'implementar', label: 'Implementar' },
  { value: 'revisar', label: 'Revisar' },
];

export { DEFAULT_PACKAGE_CREATE_STATUSES };
